/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPencilTriangleDown: {
  name: 'pencil-triangle-down';
  data: string;
} = {
  name: 'pencil-triangle-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.586 5a2 2 0 0 1 2.828 0L18 7.586l-.707.707.707-.707a2 2 0 0 1 0 2.828L9.455 18.96a2 2 0 0 1-1.193.574l-2.91.323a2 2 0 0 1-2.208-2.209l.323-2.909a2 2 0 0 1 .574-1.193l6.246-6.246.006-.006.006-.006L12.586 5Zm-7.13 9.96L11 9.413 13.586 12 8.04 17.545l-2.91.323.324-2.909ZM16.585 9 15 10.586 12.414 8 14 6.414 16.586 9ZM15.3 17.625A1 1 0 0 1 16.08 16h3.84a1 1 0 0 1 .78 1.625l-1.92 2.399a1 1 0 0 1-1.56 0l-1.92-2.4Z" fill="currentColor"/></svg>`,
};
